import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderRadioField, renderSelectField, renderTextField } from '../../../Forms/fieldRenderers'
import { FormControlLabel, Switch, Button, IconButton, makeStyles, Tooltip } from '@material-ui/core'
import CallesDeBruto from './CallesDeBruto'
import { COLORES } from '../../../../config/colores'
import CloseIcon from '@material-ui/icons/Close'
import InfoIcon from '@material-ui/icons/Info'

const useStyles = makeStyles(() => ({
  container: {
    borderRadius: '12px',
    padding: '12px',
    backgroundColor: '#dfdfdf',
    width: '90%',
    margin: 'auto'
  },
  contenidoCenter: {
    display: 'flex',
    alignItems: 'center'
  }
}))

function CamposPedidoCamiones (props) {
  const { cerealesActivos, calificaciones, handleSubmit, max } = props
  const [showCalificacion, setShowCalificacion] = useState(false)
  const [calificacionSeleccionada, setCalificacionSeleccionada] = useState(null)
  const [cerealSeleccionado, setCerealSeleccionado] = useState(null)
  const classes = useStyles()

  const renderCalificaciones = () => {
    if (!cerealSeleccionado) {
      return [<option value={null} key={0}>Seleccione primero un cereal</option>]
    }

    const options = calificaciones && calificaciones.map((calificacion) => {
      // Se especifica calificacion solo cuando se pide silo aparte, CONFORME no entra en estas opciones
      const cantidad = calificacion.cantidad - calificacion.pedidosPendientes
      if (calificacion.label !== 'Conforme' && cantidad > 0 && calificacion.cereal === cerealSeleccionado.fieldName) {
        return (
          <option
            value={calificacion.fieldName}
            key={calificacion.fieldName}
          >
            {calificacion.label.toLocaleUpperCase()} ({calificacion.cantidad})
          </option>
        )
      }
      return null
    })
    options.unshift((<option value={null} key={0}>Seleccionar condición</option>))
    return options
  }

  const closeCalificaciones = () => {
    setShowCalificacion(false)
    props.cleanCalificacion()
  }

  const handleSelectCalificacion = (e, newValue) => {
    const cal = calificaciones.find(c => c.fieldName === newValue)
    setCalificacionSeleccionada(cal)
  }

  const handleSelectCereal = (e, newValue) => {
    const cer = cerealesActivos.find(c => c.fieldName === newValue)
    setCerealSeleccionado(cer)
  }

  const handleSiloAparte = () => {
    setShowCalificacion(!showCalificacion)
    setCalificacionSeleccionada(null)
    props.cleanCalificacion()
  }

  let maxCamiones = null
  const limiteCalle = max

  if (showCalificacion && calificacionSeleccionada) {
    maxCamiones = Math.min(calificacionSeleccionada.cantidad, limiteCalle)
  } else if (cerealSeleccionado) {
    maxCamiones = Math.min(cerealSeleccionado.cantidad, limiteCalle)
  }

  const valorMaximo = maxCamiones || limiteCalle || 0
  const disabled = showCalificacion && (!calificacionSeleccionada || !calificacionSeleccionada.fieldName)

  return (
    <Row className={classes.container}>
      <Col
        md={5}
        style={{
          justifyContent: 'flex-start',
          flexDirection: 'column',
          alignItems: 'flex-start',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px'
        }}
      >
        {/* Selección rapida de cereales disponible en playa de calado */}
        <p style={{ marginLeft: '8px', marginBottom: 0 }}>Seleccionar cereal</p>
        <Field
          name='cerealPedido'
          className='radio-field'
          label='Cereal *'
          options={cerealesActivos}
          onChange={handleSelectCereal}
          component={(fieldProps) => (
            renderRadioField({
              ...fieldProps,
              wrapperStyle: { margin: 0, padding: 0, minHeight: 'auto', marginBottom: 0 }
            })
          )}
        />
        {cerealSeleccionado && !calificacionSeleccionada &&
        <small>Cantidad disponible del cereal seleccionado: {cerealSeleccionado.cantidad} </small>
        }
      </Col>
      <Col md={4} className={classes.contenidoCenter}>
        <CallesDeBruto />
      </Col>
      <Col md={3}>
        <Field
          name='cantidadPedido'
          type='number'
          label='Cantidad *'
          component={renderTextField}
          autoFocus={false}
          placeholder=''
          style={{ marginBottom: 0 }}
          max={valorMaximo}
          min={1}
        />
        { max && max >= 0 &&
          <>
            <small>Espacio disponible en calle: <b>{max}</b></small>
            <Tooltip title={'Se restan los pedidos pendientes ya realizados'}>
              <IconButton>
                <InfoIcon fontSize='small' color='primary' />
              </IconButton>
            </Tooltip>
          </>
        }
      </Col>
      <Col md={3} className={classes.contenidoCenter}>
        <FormControlLabel
          control={
            <Switch
              color='primary'
              name='siloAParte'
              onChange={handleSiloAparte}
              checked={showCalificacion}
            />
          }
          label='Silo a parte'
        />
      </Col>
      <Col md={6}>
        <>
          {showCalificacion &&
            <>
              <div style={{ width: '90%', display: 'flex' }}>
                <Field
                  name='calificacionCereal'
                  placeholder='Calificación cereal'
                  component={renderSelectField}
                  onChange={handleSelectCalificacion}
                >
                  { renderCalificaciones() }
                </Field>
                <IconButton onClick={closeCalificaciones} >
                  <CloseIcon style={{ color: COLORES.grey.dark, outline: 'none' }} />
                </IconButton>
              </div>
            </>
          }
          { showCalificacion && calificacionSeleccionada &&
            <small style={{ color: COLORES.primary, fontWeight: 'bold' }}>
              Camiones disponibles con esta condición: {calificacionSeleccionada.cantidad}
            </small>
          }
        </>
      </Col>
      <Col md={3} className={classes.contenidoCenter} style={{ justifyContent: 'flex-end' }}>
        <Button
          variant='contained'
          onClick={handleSubmit}
          disabled={disabled}
          style={{ backgroundColor: disabled ? COLORES.grey.light : COLORES.grey.dark, color: 'white', width: '100%' }}
        >
          Crear pedido
        </Button>
      </Col>
      <Col md={12} style={{ textAlign: 'rigth', marginTop: '8px' }}>
        <p>(*) Campo requerido obligatorio</p>
      </Col>
    </Row>
  )
}

export default CamposPedidoCamiones
